import React from 'react';

import {
  listManagedLoanLeads,
  ManagedLeadCategory,
} from '../../services/api/managed-leads/managedLeads';
import { MANAGED_LEAD_DETAIL_BASE_PATHS } from '../../config/managedLeadNavigation';
import ManagedLeadCard from './components/ManagedLeadCard';
import ManagedProductLeadListPage from './components/ManagedProductLeadListPage';

interface ManagedLoanListPageProps {
  category?: ManagedLeadCategory;
}

const ManagedLoanListPage = ({
  category = 'in_progress',
}: ManagedLoanListPageProps) => {
  return (
    <ManagedProductLeadListPage
      category={category}
      product="prestiti"
      listLeads={listManagedLoanLeads}
      loadingMessage="Caricamento prestiti…"
      ownerMissingMessage="Non hai un responsabile HubSpot associato. Non ci sono prestiti da mostrare."
      searchLabel="Cerca prestiti per nome, email o telefono"
      renderLead={(lead, context) => (
        <ManagedLeadCard
          key={lead.id}
          lead={lead}
          productDatum={{ label: 'Finalità', value: lead.purpose }}
          detailBasePath={MANAGED_LEAD_DETAIL_BASE_PATHS.prestiti}
          returnTo={context.returnTo}
          showNeedsUpdate={context.showNeedsUpdate}
          updateRequestProduct={
            context.showUpdateRequest ? 'prestiti' : undefined
          }
        />
      )}
    />
  );
};

export default ManagedLoanListPage;
